module.exports = __webpack_public_path__ + "static/scale-model-of-museum-of-fine-arts-in-st.-petersburg-florida-daf93e855c7df4b1ced2a9bca5ca9b08.png";